module.exports = __webpack_public_path__ + "static/media/canceled.d1c6adca.svg";